var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('div',{staticClass:"portrait",attrs:{"id":"pdf"}},[_c('Loaded'),_c('CompanySustainability',{attrs:{"doc":_vm.doc}}),_c('GTSustainability',{attrs:{"doc":_vm.doc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }